<a href="#main-content" class="visually-hidden-focusable">Skip to main content</a>

<div class="dashboard-content">
    <h1 class="visually-hidden">Dashboard</h1>

    <!-- Live region for dynamic updates -->
    <div class="visually-hidden" role="status" aria-live="polite" aria-atomic="true" #liveRegion>
    </div>

    <div class="container-fluid mt-4">
        <div class="row" id="main-content">
            <div class="col-xxl-1"></div>
            <div class="col-xxl-10">
                @if(announcementData())
                {
                <div class="row">
                    <div class="col-12">
                        <app-announcement [announcementItem]="announcementData()"></app-announcement>
                    </div>
                </div>
                }
                <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-4 mb-3 d-none d-md-block">
                        <div class="dashboard-card card-get-started d-flex flex-column justify-content-between">
                            <div>
                                <h2 class="text-bold">Welcome to DASH!</h2>
                                <p>
                            Your online connection to San Bernardino Superior Court Self-Help Services.<br/>
                            Submit a Service Request, upload documents, and communicate with Self-Help staff through a secure online experience.<br/>
                            <i>Self-Help staff provide neutral assistance and do not represent either party in a case.</i>
                                </p>
                            </div>

                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-4 mb-3">
                        <div class="card dashboard-card card-service-request">
                            <h2 class="text-center text-md-start text-bold">Open a Service Request</h2>
                            <p>
                                Create a <span class="accent-text">Service Request</span>, and receive
                                <span class="accent-text">form assistance</span> and <span class="accent-text">form
                                    reviews</span>.
                            </p>
                            <div class="card-footer card-footer-no-border">
                                <div class="row align-items-center">
                                    <div class="col-12">
                                        <div class="d-grid gap-2 text-center">
                                            <button class="btn btn-lg" mdbRipple
                                                aria-label="Open a new service request for form assistance"
                                                routerLink="/service-requests">
                                                Open a Service Request
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-4 mb-3">
                        <div class="card dashboard-card card-workshops">
                            <h2 class="text-center text-md-start text-bold">Sign Up for a Workshop</h2>
                            <p>
                                Join a <span class="accent-text">Workshop</span>, search for exiting
                                workshops, and view previous sessions.
                            </p>
                            <div class="card-footer card-footer-no-border">
                                <div class="row align-items-center">
                                    <div class="col-12">
                                        <div class="d-grid gap-2 text-center">
                                            <button class="btn btn-lg" mdbRipple
                                                aria-label="Open my workshops page"
                                                routerLink="/my-workshops">
                                                My Workshops
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <!-- Get Started Card
                    <div class="col-sm-12 col-md-6 col-lg-4 mb-3">
                        <div class="card dashboard-card card-get-started">
                            <h2 class="text-center text-md-start text-bold">Get Started</h2>
                            <p>
                                Explore available <span class="accent-text">forms</span>,
                                <span class="accent-text">kits</span> and helpful resources. Find which form best suits
                                your needs here.
                            </p>
                            <div class="card-footer card-footer-no-border text-center text-md-start">
                                <div class="row align-items-center">
                                    <div class="col-12">
                                        <div class="d-grid gap-2 text-center">
                                            <button class="btn btn-lg" mdbRipple
                                                aria-label="Get started with forms and resources">
                                                Start Here!
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-2"></div>
                                </div>
                            </div>
                        </div>
                    </div>  -->

                    <!-- Welcome card -->
                <!-- <div class="col-sm-12 col-md-6 col-lg-6 mb-3 d-none d-md-block">
                    <div class="dashboard-card card-get-started d-flex flex-column justify-content-between">
                        <div>
                            <h2 class="text-bold">Welcome to DASH!</h2>
                            <p>
                Your online connection to San Bernardino Superior Court Self-Help Services.<br/>
                Submit a Service Request, upload documents, and communicate with Self-Help staff through a secure online experience.<br/>
                <i>Self-Help staff provide neutral assistance and do not represent either party in a case.</i>

                            </p>
                        </div>
                <div class="card-footer card-footer-no-border p-0 my-auto">
                    <app-gradientsegmentbar [noMargins]="true"></app-gradientsegmentbar>
                </div>
                    </div>
                </div> -->
                    <!-- Service Request Card -->
                    <!-- <div class="col-sm-12 col-md-6 col-lg-6 mb-3">
                        <div class="card dashboard-card card-service-request">
                            <h2 class="text-center text-md-start text-bold">Open a Service Request</h2>
                            <p>
                                Create a <span class="accent-text">Service Request</span>, and receive
                                <span class="accent-text">form assistance</span> and <span class="accent-text">form
                                    reviews</span>.
                            </p>
                            <div class="card-footer card-footer-no-border">
                                <div class="row align-items-center">
                                    <div class="col-12">
                                        <div class="d-grid gap-2 text-center">
                                            <button class="btn btn-lg" mdbRipple
                                                aria-label="Open a new service request for form assistance"
                                                routerLink="/service-requests">
                                                Open a Service Request
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <!-- Link Cases Card 
                    <div class="col-sm-12 col-md-12 col-lg-4 mb-3">
                        <div class="card dashboard-card card-linked-cases">
                            <div class="row align-items-center">
                                <div class="col-md-6 col-sm-12 mb-3 mb-md-0">
                                    <h2 class="text-center text-md-start text-bold">Link Cases</h2>
                                    <p>
                                        <span class="accent-text">Cases</span> can be
                                        <span class="accent-text">linked</span> to your account for quick access.
                                    </p>
                                </div>
                                <div class="col-md-6 col-sm-12 mb-2 px-2">
                                    <div class="row" role="list" aria-label="Linked cases">
                                        @if(dashboardData()?.linkedCases?.length) {
                                        @for (linkedCase of dashboardData()?.linkedCases; track $index) {
                                        <div class="col-6 col-md-12 mb-2 d-flex align-items-center" role="listitem">
                                            <a href="{{linkedCase.url}}" class="case-id-item"
                                                aria-label="View case {{linkedCase.caseId}}">
                                                {{linkedCase.caseId}}
                                            </a>
                                        </div>
                                        }
                                        } @else {
                                        <div class="col-12 col-md-12 mb-2 d-flex align-items-center">
                                            <div class="case-id-item-empty" role="status" aria-live="polite">
                                                No Linked Cases
                                            </div>
                                        </div>
                                        }
                                    </div>
                                </div>
                                <div class="card-footer card-footer-no-border">
                                    <div class="row align-items-center">
                                        <div class="col-12">
                                            <div class="d-grid gap-2 text-center">
                                                <button class="btn btn-lg" type="button" mdbRipple
                                                    aria-label="Link a case to your account">
                                                    Link a Case
                                                </button>
                                            </div>
                                        </div>
                                        <div class="col-2"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div> 
                <div clas="row g-4">
                                        <div class="col-12 col-lg-12 d-flex flex-column" style="gap: 24px;" role="region"
                        aria-label="Service Requests" [class.equal-height-col]="isEmpty()">
                        <!-- Service Requests -->
                        <app-service-request-card [serviceRequests]="userServiceRequests() ?? []"
                        [isLoading]="isServiceRequestLoading()"
                            role="region" aria-label="Active service requests">
                        </app-service-request-card>
                        </div>
                </div>
                <!-- Two Column Layout using Bootstrap Grid 
                <div class="row g-4"> 
                    <!-- Left Column 
                    <div class="col-12 col-lg-6 d-flex flex-column" style="gap: 24px;" role="region"
                        aria-label="Notifications and service requests" [class.equal-height-col]="isEmpty()"> 

                        <!-- Inbox / Notifications 
                        <!--  <app-inbox-notification-card [notifications]="dashboardData()?.notifications ?? []"
                            (inboxClick)="onInboxClick()" (notificationClick)="onNotificationClick($event)"
                            role="region" aria-label="Inbox and notifications">
                        </app-inbox-notification-card> 


                    </div>

                    <!-- Right Column 
                    <div class="col-12 col-lg-6 d-flex flex-column" style="gap: 24px;" role="region"
                        aria-label="Important dates and appointments" [class.equal-height-col]="isEmpty()">

                        <!-- Service Requests 
                        <app-service-request-card [serviceRequests]="userServiceRequests() ?? []"
                            role="region" aria-label="Active service requests">
                        </app-service-request-card>

                        <!-- Upcoming Important Dates 
                        <app-important-dates-card [hearings]="dashboardData()?.hearings ?? []" role="region"
                            aria-label="Upcoming important dates">
                        </app-important-dates-card> 

                        <!-- Appointments 
                        <app-appointment-card [appointments]="dashboardData()?.appointments ?? []" role="region"
                            aria-label="Upcoming appointments">
                        </app-appointment-card>
                    </div>
                </div> -->
            </div>
            <div class="col-xxl-1"></div>
        </div>
    </div>
</div>

<!-- Gradient Bar - Pushed to bottom -->
<footer class="gradient-bar-footer" role="contentinfo" aria-label="Page footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-xxl-1"></div>
            <div class="col-xxl-10">
                <app-gradientsegmentbar role="presentation" aria-hidden="true"></app-gradientsegmentbar>
            </div>
            <div class="col-xxl-1"></div>
        </div>
    </div>
</footer>